// Date presets and option lists for report filter bars.
//
// Dates are the browser's LOCAL calendar day. The API reads YYYY-MM-DD as the merchant's
// calendar day, and toISOString() (UTC) would hand it yesterday between 00:00 and 03:00
// Riyadh time.

const pad = (n) => String(n).padStart(2, "0");

export const ymdLocal = (d = new Date()) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export const daysAgo = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return ymdLocal(d);
};

const monthStart = () => {
  const d = new Date();
  d.setDate(1);
  return ymdLocal(d);
};

export const DATE_PRESETS = [
  { label: "Today", value: "today", range: () => [ymdLocal(), ymdLocal()] },
  { label: "Last 7 Days", value: "7d", range: () => [daysAgo(7), ymdLocal()] },
  { label: "Last 30 Days", value: "30d", range: () => [daysAgo(30), ymdLocal()] },
  { label: "This Month", value: "month", range: () => [monthStart(), ymdLocal()] },
  { label: "This Year", value: "year", range: () => [`${new Date().getFullYear()}-01-01`, ymdLocal()] },
  { label: "All Time", value: "all", range: () => ["", ""] },
];

// Every order nature. Selecting all of them is "no filter" on the API.
export const ORDER_NATURE_OPTIONS = [
  { value: "normal", label: "Normal" },
  { value: "loyalty", label: "Loyalty" },
  { value: "thirdParty", label: "Third Party" },
  { value: "waiter", label: "Waiter" },
  { value: "kiosk", label: "Kiosk" },
];

export const GRANULARITY_LABEL = { day: "daily", week: "weekly", month: "monthly" };
